import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import App from "./App";
import i18n from './i18n';
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import './CSS/global.css';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </I18nextProvider>
);
